import React from 'react';

// Importing icons to match the card style
import TuneIcon from '@material-ui/icons/Tune';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import BarChartIcon from '@material-ui/icons/BarChart';
import ArchiveIcon from '@material-ui/icons/Archive';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'Scenario', value: 'Premium +5 pp', delta: 'selected', tone: 'blue', icon: <TuneIcon />, deltaTone: 'blue' },
    { label: 'Revenue', value: '+₹22 Cr', delta: 'vs base', tone: 'green', icon: <AttachMoneyIcon />, deltaTone: 'good' },
    { label: 'EBITDA', value: '+₹6 Cr', delta: 'vs base', tone: 'purple', icon: <BarChartIcon />, deltaTone: 'good' },
    { label: 'Inventory', value: '-₹12 Cr', delta: 'vs base', tone: 'orange', icon: <ArchiveIcon />, deltaTone: 'good' },
];

const SLIDER_INPUTS = [
    { label: 'Demand +10%', value: 60 },
    { label: 'Premium Mix +5 pp', value: 50 },
    { label: 'South Capacity -10%', value: 50 },
    { label: 'Inventory Target 24d', value: 55 },
];

const OUTCOME_DATA = [
    { metric: 'Demand covered', base: '95.0%', scenario: '96.4%', optimized: '98.8%' },
    { metric: 'Revenue', base: 'Base', scenario: '+₹14 Cr', optimized: '+₹22 Cr' },
    { metric: 'EBITDA', base: 'Base', scenario: '+₹3 Cr', optimized: '+₹6 Cr' },
    { metric: 'Inventory', base: '28d', scenario: '27d', optimized: '24d' },
];

const DECISION_DATA = [
    { decision: 'North production', base: '1.45M', optimized: '1.60M' },
    { decision: 'South production', base: '1.48M', optimized: '1.49M' },
    { decision: 'Deploy West', base: '620k', optimized: '700k' },
    { decision: 'Premium priority', base: 'Normal', optimized: 'High' },
    { decision: 'Cash', base: '—', optimized: '+₹12 Cr' },
];

export class Scenario extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Scenario Simulation Studio</h1>
                        <p>Test demand, premium mix, capacity and inventory scenarios before changing the operating plan.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the card style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: Scenario Inputs & Outcome */}
                    <div className="cc-panel">
                        <h2>Scenario Inputs</h2>
                        
                        {/* Sliders */}
                        <div className="cc-sliders-container">
                            {SLIDER_INPUTS.map((slider) => (
                                <div className="cc-slider-row" key={slider.label}>
                                    <div className="cc-slider-label">{slider.label}</div>
                                    <div className="cc-slider-track">
                                        <div className="cc-slider-fill" style={{ width: `${slider.value}%` }}></div>
                                        <div className="cc-slider-thumb" style={{ left: `calc(${slider.value}% - 10px)` }}></div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Outcome Table */}
                        <table className="cc-actions-table cc-table-striped cc-table-light cc-outcome-table">
                            <thead>
                                <tr>
                                    <th>Outcome</th>
                                    <th>Base</th>
                                    <th>Scenario</th>
                                    <th>Optimized</th>
                                </tr>
                            </thead>
                            <tbody>
                                {OUTCOME_DATA.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.metric}</td>
                                        <td>{row.base}</td>
                                        <td>{row.scenario}</td>
                                        <td>{row.optimized}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Right Panel: Base Plan vs Optimized Outcome */}
                    <div className="cc-panel cc-panel-table ">
                        <h2>Base Plan vs Optimized Outcome</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light" style={{marginTop: '20px'}}>
                            <thead>
                                <tr>
                                    <th>Decision</th>
                                    <th>Base</th>
                                    <th>Optimized</th>
                                </tr>
                            </thead>
                            <tbody>
                                {DECISION_DATA.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.decision}</td>
                                        <td>{row.base}</td>
                                        <td>{row.optimized}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Scenario;